<template>
    <div v-if="weather" class="weather">
        <div class="current-weather">
            <div class="current-temp">
                <h2>{{ weather.data.temperature }}&#176;</h2>
                <h3>{{ weather.data.city }}</h3>
            </div>
            <div class="current-condition">
                <img :src="weather.data.condition.icon" :alt="weather.data.condition.text">
            </div>
        </div>
        <div class="forecast">
            <div v-for="weather in weather.data.forecast_next_6h">
                <p>{{ weather.hour }}&nbsp;h</p>
                <img :src="weather.condition.icon" :alt="weather.condition.text">
                <p>{{ weather.temp_c }}&#176;</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import apiClient                       from '@/api'

const weather  = ref(null)
let intervalId = null
let timeoutId  = null

// Fetch weather from API
const fetchWeather = async () => {
    try {
        const response = await apiClient.get('get_weather/')
        console.log(response.data.message, response.data.data)
        // Check if data changed before replacing
        if (JSON.stringify(weather.value) !== JSON.stringify(response.data)) {
            weather.value = response.data
        }
    } catch (error) {
        console.error('Error fetching weather:', error)
    }
}

// Schedule first fetch
const scheduleFirstFetch = () => {
    const now     = new Date()
    const seconds = now.getSeconds()
    const minutes = now.getMinutes()

    let msUntilNextFetch

    if (minutes === 0) {
        // Wait 30s to get forecast starting next hour
        msUntilNextFetch = (30 - seconds) * 1000
    } else {
        // Otherwise, align to next 5-minute mark
        const nextMultipleOf5 = Math.floor(minutes / 5) * 5 + 5
        msUntilNextFetch      = (nextMultipleOf5 * 60 - minutes * 60 - seconds) * 1000
    }

    timeoutId = setTimeout(() => {
        fetchWeather()
        // Repeat every 5 minutes from now
        intervalId = setInterval(fetchWeather, 5 * 60 * 1000)
    }, msUntilNextFetch)
}

onMounted(async () => {
    await fetchWeather() // initial fetch
    scheduleFirstFetch()
})

onUnmounted(() => {
    if (intervalId) clearInterval(intervalId)
    if (timeoutId)  clearTimeout(timeoutId)
})
</script>

<style lang="scss" scoped>
.weather {
    width: 100%;

    .current-weather {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;

        justify-content: center;

        h2, h3 {
            margin: 0;
            line-height: 1;

            text-align: start;
            text-transform: uppercase;
            font-weight: normal;

            color: $dark-blue
        }

        h2 {
            font-size: 4vw;
        }

        h3 {
            font-size: 2vw;
        }

        .current-condition {
            img {
                width: 10vw;
                height: auto;
            }
        }
    }

    .forecast {
        display: grid;

        width: 100%;
        
        grid-template-columns: repeat(6, 1fr);
        justify-content: space-between;

        p {
            margin: 0;

            font-size: 1vw;
            color: $dark-blue;
        }

        img {
            width: 3vw;
            height: auto;
        }
    }
}
</style>